 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      RI Company Helplist
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryRiCoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryRiCoFilterForm"
                            v-model="filtersRiCo.riCo"
                            :label="filtersAgencyLabel.riCo"
                            :error-messages="errors.collect('filterRiCo')"
                            data-vv-name="filterRiCo"
                            :data-vv-as="filtersAgencyLabel.riCo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryRiCoFilterForm"
                            v-model="filtersRiCo.riType"
                            :label="filtersAgencyLabel.riType"
                            :error-messages="errors.collect('filterRiType')"
                            data-vv-name="filterRiType"
                            :data-vv-as="filtersAgencyLabel.riType"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="headers"
          :items="riCoItems"
          v-bind:options.sync="paginationRiCo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItems"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.riCo }}</td>
              <td>{{ row.item.riType }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignRiCo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersAgencyLabel: {
        riCo: 'RI Company',
        riType: 'RI Type'
      },
      filtersRiCo: {
        riCo: null,
        riType: undefined,
        polNo: undefined,
        renCnt: null,
        endtCnt: null
      },
      riCoItems: [],
      totalItems: 0,
      headers: [
        { text: 'RI Company', align: 'left', value: 'riCo' },
        { text: 'RI Type', align: 'left', value: 'riType' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationRiCo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    'paginationRiCo': function (value) {
      this.fetchRiCo()
    }
  },
  mounted() {
    this.doClearFilters()
  },
  methods: {
    closeDialog() {
      this.filtersRiCo.riCo = ''
      this.filtersRiCo.riType = ''
      this.$emit('close')
    },
    doClearFilters() {
      this.filtersRiCo.riCo = ''
      this.filtersRiCo.riType = ''
      this.filtersRiCo.polNo = this.objData.polNo
      this.filtersRiCo.renCnt = this.objData.renCnt
      this.filtersRiCo.endtCnt = this.objData.endtCnt
      this.fetchRiCo()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryRiCoFilterForm').then((result) => {
        if (result) {
          this.paginationRiCo.page = 1
          this.fetchRiCo()
        }
      })
    },
    assignRiCo(data) {
      this.$emit('assign-riCo', data)
      this.$emit('close')
      this.doClearFilters()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin],
  props: {
    objData: {
      type: Object,
      default: null
    }
  }
}
</script>
